import { ref } from 'vue';

const toasts = ref([]);
let toastId = 0;

const showToast = (message, type = 'info', duration = 5000, title = 'Notification') => {
  const id = toastId++;
  const now = new Date();
  const time = now.toLocaleTimeString();

  toasts.value.push({
    id,
    message,
    type,
    title,
    time,
  });

  if (duration > 0) {
    setTimeout(() => {
      removeToast(id);
    }, duration);
  }
};

const removeToast = (id) => {
  toasts.value = toasts.value.filter(toast => toast.id !== id);
};

const showSuccessToast = (message, title = 'Success', duration = 5000) => {
  showToast(message, 'success', duration, title);
};

const showErrorToast = (message, title = 'Error', duration = 5000) => {
  showToast(message, 'danger', duration, title);
};

const showInfoToast = (message, title = 'Info', duration = 5000) => {
  showToast(message, 'info', duration, title);
};

const showWarningToast = (message, title = 'Warning', duration = 5000) => {
  showToast(message, 'warning', duration, title);
};

export function useToast() {
  return {
    toasts,
    showToast,
    removeToast,
    showSuccessToast,
    showErrorToast,
    showInfoToast,
    showWarningToast,
  };
}
